module.exports = __webpack_public_path__ + "img/parasight_fungal_pod.b248408f.png";